import i18n from 'modules/core/lib/i18n'
import type { Navigation, NavigationPaths } from 'modules/core/lib/navigation/context'

import type { Tab } from 'modules/payroll_bundle/lib/types'

interface Props {
  navigation: Navigation<NavigationPaths>
  hasPayments: boolean
  hasResults: boolean
  policyId?: string
  periodId?: string
  seeCompanyPayrollResults?: boolean
  isOffCycle?: boolean
}

export const getTabs = ({
  navigation,
  hasResults,
  hasPayments,
  policyId,
  periodId,
  seeCompanyPayrollResults,
  isOffCycle,
}: Props): Tab[] => {
  if (!policyId || !periodId) {
    return []
  }

  let tabs: Tab[] = []

  const supplementsTabName = i18n.t(
    'payroll_bundle.policy_period.status.phases.supplements_definition_v2'
  )
  const calculationTabName = i18n.t(
    'payroll_bundle.policy_period.status.phases.payroll_calculation_v2'
  )
  const paymentTabName = i18n.t('payroll_bundle.policy_period.status.phases.payment_v2')

  const supplementsHref = navigation.payrollBundle.policy.period.cycles.supplements.fullPath({
    policyId,
    periodId,
  })

  let { calculationHref, paymentHref }: { calculationHref: string; paymentHref: string } = {
    calculationHref: '',
    paymentHref: '',
  }

  if (isOffCycle) {
    calculationHref = navigation.payrollBundle.policy.period.offcycles.results.fullPath({
      policyId,
      periodId,
    })
    paymentHref = navigation.payrollBundle.policy.period.offcycles.payments.fullPath({
      policyId,
      periodId,
    })
  } else {
    calculationHref = navigation.payrollBundle.policy.period.cycles.results.fullPath({
      policyId,
      periodId,
    })
    paymentHref = navigation.payrollBundle.policy.period.cycles.payments.fullPath({
      policyId,
      periodId,
    })
  }

  if (!isOffCycle) {
    tabs.push({
      name: supplementsTabName,
      href: supplementsHref,
      isNavigable: true,
    })
  }

  if (seeCompanyPayrollResults) {
    tabs = tabs.concat([
      {
        name: calculationTabName,
        href: calculationHref,
        isNavigable: true,
      },
      {
        name: paymentTabName,
        href: paymentHref,
        isNavigable: hasResults || hasPayments,
      },
    ])
  }

  return tabs
}
